import type { ProductDto } from "../api/products-api";
import { formatMoney } from "./invoice-mappers";

export function productToTableRow(p: ProductDto, index: number) {
  return {
    key: p.id,
    rowId: p.id,
    Image: `product-${String((index % 6) + 1).padStart(2, "0")}.jpg`,
    Code: p.code,
    Product: p.name,
    Category: p.category?.name ?? "—",
    Unit: p.unit.symbol,
    Quantity: String(p.quantityOnHand),
    Selling_Price: formatMoney(p.sellingPrice, "USD"),
    Purchase_Price: formatMoney(p.purchasePrice, "USD"),
    Item_Type: p.itemType,
    Status: p.status,
  };
}

export function productToInventoryRow(p: ProductDto, index: number) {
  return {
    ...productToTableRow(p, index),
    Product_Service: p.name,
  };
}
